import UseOutsideClick from './UseOutsideClick'
export default UseOutsideClick
